module.exports = __webpack_public_path__ + "static/henri_benard-74d541e721d186e0d664970fdeba2368.png";